<template>
    <div class="charpter_tree">
 <div class="mt-5 p-5">
      <h1 class="font-weight-bolder">Educación virtual o Presencial</h1>
      <p class="mt-5">
        En el camino es donde mas se aprende, y en mi recorrido por las sendas
        del desarrollo web. He podido diferenciar las ventajas de la educación
        100% virtual y la educación presencial.
      </p>
      <p>
        En 2005 llego el gigante conocido como YOUTUBE. Al principio era un
        portal reconocido por la cantidad contenidos que se podían encontrar
        allí, había videos para todos los gustos.
      </p>
      <p>
        Fueron pasando los años y la plataforma fue cambiando y con este, sus
        usuarios. El pago por las vistas de los contenidos motivó a los usuarios
        a subir más material para obtener réditos sacando provecho de sus
        conocimientos, artísticos, audiovisuales, intelectuales etc.
      </p>
      <p>
        Esta plataforma al igual que muchas otras se convirtieron en una fuente
        de información muy utilizada por las personas para buscar información
        concreta de cómo realizar cualquier procedimiento, incluso hay
        tutoriales de como cambiar la rueda de un carro y como preparar un
        delicioso postre de fresas o un sheesecake, o aprender a
        <strong>programar desde cero.</strong>
      </p>
      <p>
        Las personas siempre están en busca de una idea, un negocio algo que le
        permita cumplir sus metas económicas y también realizarse como persona y
        compartir su conocimiento con los demás.
      </p>
      <p>
        Al analizar los datos del numero de usuarios que ingresaban a estas
        plataformas, a muchas empresas se les ocurrió la idea de virtualizar la
        educación. Esta idea ya venía de muchos años atrás, pero la
        materialización no era fácil. Viendo las ventajas que el internet
        proporcionaba y ese avance tecnológico que crece con una rapidez
        inimaginable. El internet permitió llevar a cabo todas estas ideas, la
        implementación de plataformas web robustas y adaptadas para proporcionar
        contenidos educativos a sus usuarios. La oferta educativa virtual se
        incrementó ocasionando que incluso muchas universidades que tenían como
        método principal la educación presencial, se adaptaran y empezaran a
        impartir algunas ofertas y cursos académicos 100% virtuales.
      </p>
      <p>
        Como era de esperarse, los cambios tienen sus seguidores y sus
        opositores quienes estaban a favor de la educación virtual empezaron a
        decir que la educación presencial no era necesaria y veían en la
        educación virtual la solución a las falencias que tenía la educación
        presencial y tradicional. Para nadie es un secreto que la educación
        tradicional tiene muchas falencias y no solo a nivel nacional sino
        también internacional, que la educación es un sistema con mas de 200
        años de antigüedad donde se premia al estudiante con mejores notas sin
        tener en cuenta la diversidad en las diferentes formas de inteligencia y
        de aprendizaje. Pero ese es otro asunto del cual no quiero tocar en este
        escrito.
      </p>
      <p>
        Como en otras ocasiones les he comentado la mayoría de las cosas que
        escribo, son basadas en mi experiencia. Mi educación ha sido un 90% en
        línea, he podido probar diferentes plataformas de educación virtual,
        tanto de pago como gratuitas, he logrado sacar provecho de estas gracias
        a la constancia y la disciplina. Pero he aquí el punto de quiebre del
        cual les quiero contar y es que basado en mis largos años de aprendizaje
        en línea y para aclarar el interrogante que al día de hoy a muchas
        personas tiene inquietado y sin saber cual de los dos métodos utilizar
        para obtener la mejor formación educativa posible.
      </p>
      <p>
        El interrogante constante es:
        <strong>¿cuál de los métodos es mejor?</strong> Este interrogante surge
        por una razón natural y es que los seres humanos siempre estamos
        comparando para ver quien o cual es mejor y cual no lo es. Entonces
        existe una gran dicotomía respecto a este tema. Es más, he leído en
        foros de discusión donde muchas personas preguntan si entran a la
        universidad o mejor o mejor tomar cursos virtuales y aprender de forma
        autodidacta, y he vistos respuestas como: “no desperdicies tu dinero”.
        Déjame decirte que “Las comparaciones empobrecen” y para dar un poco de
        luz a este interrogante quiero decirte que ambas formas de educación son
        importantes y una se complementa con la otra. Refiriéndonos al tema de
        <strong>la programación</strong>, la formación presencial proporciona
        una base fundamental sólida al estudiante, que le permite tener un
        desempeño optimo y le da la capacidad de resolver problemas realmente
        complejos, algo que la formación virtual no le puede brindar. Otra de
        las razones por las cuales yo estoy en favor de la educación Presencial
        es que el estudiante tiene una interacción interpersonal, algo
        profundamente fundamental que potencia el aprendizaje. El hecho de tener
        personas cerca, tales como los docentes que pueden brindar una
        asistencia continua para despejar las dudas y los mismos compañeros de
        clase para socializar diversos temas, ejercitar el trabajo en equipo
        etc. Es algo muy positivo en el proceso del aprendizaje.
      </p>
      <p>
        La educación virtual también tiene sus aspectos positivos tales como
        brindar la posibilidad de realizarla en la comodidad del hogar, en el
        tiempo que se tiene disponible, también se tiene acceso al contenido y
        esto permite repetir las explicaciones o los procedimientos las veces
        que sea necesario.
      </p>
      <p>
        En muchas ocasiones y por el limite de tiempo que se tiene en el
        ejercicio de la educación presencial,
        <strong>la educación virtual</strong> toma un papel muy importante,
        porque permite ampliar las explicaciones o los procedimientos que por
        razones de tiempo no se pudieron abarcar en su totalidad o en la
        profundad necesaria para una comprensión adecuada.
      </p>
      <p>
        En síntesis, los dos métodos de educación tanto presencial o virtual son
        indispensables, ambas se complementan. Lo mejor no es compararlas para
        tratar de buscar la mejor o la peor, sino aprovechar las ventajas que
        ambas ofrecen y así poder sacar el mejor provecho posible.
      </p>
 </div>

    </div>
</template>
<script>
export default {
    name:"charpter_tree"
}
</script>
<style lang="scss" scoped>
p,li{
  
  font-size: 20px;;

}
</style>